import { auth, db } from "./firebaseConfig"; // Ensure consistent imports
import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  GoogleAuthProvider,
  signInWithPopup,
  signOut,
  sendPasswordResetEmail,
  updatePassword,
  sendEmailVerification,
} from "firebase/auth";
import { doc, setDoc, getDoc } from "firebase/firestore"; // Firestore functions

// Create user with email and password, and store user data in Firestore
export const doCreateUserWithEmailAndPassword = async (email, password, username) => {
  try {
    const userCredential = await createUserWithEmailAndPassword(auth, email, password);
    const user = userCredential.user;

    // Firestore: Add new user to 'users' collection
    await setDoc(doc(db, "users", user.uid), {
      email: user.email,
      username: username,  // Save username entered during sign-up
      danceStyles: []      // Initialize with empty dance styles
    });
  } catch (error) {
    console.error(error.message);
  }
};

// Sign in user with email and password
export const doSignInWithEmailAndPassword = async (email, password) => {
  try {
    await signInWithEmailAndPassword(auth, email, password);
  } catch (error) {
    console.error(error.message);
  }
};

// Google Sign-In and add user data if new
export const doSignInWithGoogle = async () => {
  try {
    const provider = new GoogleAuthProvider();
    const userCredential = await signInWithPopup(auth, provider);
    const user = userCredential.user;

    // Firestore: Check if user already exists, else add them
    const docRef = doc(db, "users", user.uid);
    const docSnap = await getDoc(docRef);
    if (!docSnap.exists()) {
      await setDoc(doc(db, "users", user.uid), {
        email: user.email,
        username: user.displayName,  // Save displayName from Google
        danceStyles: [],
        role: null,              // Initialize empty dance styles
      });
      return { newUser: true };
    }
    return { newUser: false, role: docSnap.data().role };
  } catch (error) {
    console.error(error.message);
  }
};

// Sign out user
export const doSignOut = async () => {
  try {
    await signOut(auth);
  } catch (error) {
    console.error(error.message);
  }
};

// Send password reset email
export const doPasswordReset = async (email) => {
  try {
    await sendPasswordResetEmail(auth, email);
  } catch (error) {
    console.error(error.message);
  }
};

// Update password for the current user
export const doPasswordUpdate = async (password) => {
  try {
    await updatePassword(auth.currentUser, password);
  } catch (error) {
    console.error(error.message);
  }
};

// Send email verification to the current user
export const doSendEmailVerification = async () => {
  try {
    await sendEmailVerification(auth.currentUser);
  } catch (error) {
    console.error(error.message);
  }
};
